import React, { useState, useEffect, useCallback } from "react";
import { SERVER_URL, CUTOFF_DATE } from "../../../constants.js";
import "../PaymentsCard.css";
import IconButton from "@mui/material/IconButton";
import { Delete } from "@mui/icons-material";
import { submitPaymentWithDuplicateGuard } from "../../shared utils/Payments.js";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import PaymentDialog from "../../AddsEdits/Student/PaymentDialog";

function StudentPayments(props) {
    const { selectedPerson } = props;
    const [payments, setPayments] = useState([]);
    const [toastOpen, setToastOpen] = useState(false);
    const [toastMessage, setToastMessage] = useState("");
    const [toastSeverity, setToastSeverity] = useState("success");
    const [editingPayment, setEditingPayment] = useState(null);

    const Alert = React.forwardRef(function Alert(props, ref) {
        return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
    });

    const showToast = (message, severity = "success") => {
        setToastMessage(message);
        setToastSeverity(severity);
        setToastOpen(true);
    };

    const fetchPayments = useCallback(() => {
        const token = sessionStorage.getItem("bearer");
        fetch(`${SERVER_URL}api/payments/${selectedPerson.id}`, {
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                if (response.status === 204) {
                    return [];
                } else if (response.ok) {
                    return response.json();
                } else {
                    showToast("Failed to fetch payments", "error");
                }
            })
            .then((data) => {
                // Filter payments that are newer than the cutoff date
                const filteredPayments = data.filter(
                    (payment) =>
                        new Date(payment.paymentdate) >= new Date(CUTOFF_DATE)
                );
                sessionStorage.setItem(
                    "payments",
                    JSON.stringify(filteredPayments)
                );
                setPayments(filteredPayments);
            })
            .catch((err) => console.error(err));
    }, [selectedPerson.id]);

    useEffect(() => {
        fetchPayments();
    }, [fetchPayments]);

    const deletePayment = (event, payment) => {
        event.preventDefault();

        const token = sessionStorage.getItem("bearer");
        const id = payment.id;

        fetch(`${SERVER_URL}api/payments/${id}`, {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        })
            .then((response) => {
                if (response.ok) {
                    showToast("Payment deleted", "success");
                    fetchPayments();
                } else {
                    showToast("Failed to delete payment", "error");
                    console.error(response.statusText);
                }
            })
            .catch((error) => {
                showToast("Failed to delete payment", "error");
                console.error(error);
            });
    };

    return (
        <React.Fragment>
            <div
                className="detail-card payments-card"
                style={{ padding: "20px 0" }}
            >
                <table
                    style={{
                        width: "80%",
                        textAlign: "left",
                        margin: "auto",
                        borderCollapse: "collapse",
                    }}
                >
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Payment Date</th>
                            <th>Payment Amount</th>
                            <th>Payment Account</th>
                        </tr>
                    </thead>
                    <tbody>
                        {payments.map((payment) => (
                            <tr key={payment.id}>
                                <td>{payment.id}</td>
                                <td>{payment.paymentdate}</td>
                                <td>£ {payment.paymentamount}</td>
                                <td>{payment.paymentaccount}</td>
                                <td>
                                    <IconButton
                                        onClick={() =>
                                            setEditingPayment(payment)
                                        }
                                    >
                                        <EditIcon color="primary" />
                                    </IconButton>
                                    <IconButton
                                        onClick={(event) =>
                                            deletePayment(event, payment)
                                        }
                                    >
                                        <Delete color="primary" />
                                    </IconButton>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <PaymentDialog
                studentId={selectedPerson.id}
                addPayment={(payment) =>
                    submitPaymentWithDuplicateGuard(
                        selectedPerson.id,
                        payment
                    ).then((result) => {
                        if (result.ok) {
                            showToast("Payment added successfully", "success");
                            fetchPayments();
                        } else if (!result.cancelled) {
                            showToast("Failed to add payment", "error");
                        }
                        // keep the dialog open if the user declined the duplicate
                        return result.cancelled;
                    })
                }
                trigger={
                    <IconButton>
                        <AddIcon color="primary" />
                    </IconButton>
                }
            />
            <div>
                <p style={{ color: "#999999", fontSize: "10px" }}>
                    Student: {selectedPerson.id}
                </p>
                <p style={{ color: "#999999", fontSize: "10px" }}>
                    Is authenticated:{" "}
                    {sessionStorage.getItem("isAuthenticated").toString()}
                </p>
            </div>
            {editingPayment && (
                <PaymentDialog
                    open={Boolean(editingPayment)}
                    onClose={() => setEditingPayment(null)}
                    studentId={selectedPerson.id}
                    initialData={editingPayment}
                    addPayment={(payment) => {
                        return submitPaymentWithDuplicateGuard(
                            selectedPerson.id,
                            payment
                        ).then((result) => {
                            if (result.ok) {
                                showToast("Payment updated successfully");
                                fetchPayments();
                            } else if (!result.cancelled) {
                                showToast("Failed to update payment", "error");
                            }
                            return result.cancelled;
                        });
                    }}
                />
            )}

            <Snackbar
                open={toastOpen}
                autoHideDuration={3000}
                onClose={() => setToastOpen(false)}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            >
                <Alert
                    onClose={() => setToastOpen(false)}
                    severity={toastSeverity}
                >
                    {toastMessage}
                </Alert>
            </Snackbar>
        </React.Fragment>
    );
}

export default StudentPayments;
